import { forwardRef } from 'react';
import { IconButton as MuiIconButton } from '@mui/material';
import { colorTokens, radiusTokens } from '../../app/designTokens';

const { semantic } = colorTokens;

const SIZE_MAP = {
  Sm: 32,
  sm: 32,
  Md: 40,
  md: 40,
};

const TONE_STYLES = {
  Neutral: {
    bgcolor: semantic.action.secondary.bg,
    color: semantic.text.primary,
    border: `1px solid ${semantic.border.default}`,
    '&:hover': {
      bgcolor: semantic.bg.surface,
      borderColor: semantic.text.muted,
      color: semantic.text.primary,
    },
    '&:active': {
      bgcolor: semantic.bg.input,
    },
  },
  Danger: {
    bgcolor: semantic.action.secondary.bg,
    color: semantic.error,
    border: `1px solid ${semantic.border.default}`,
    '&:hover': {
      bgcolor: semantic.status.brand.bg,
      borderColor: semantic.status.brand.border,
      color: semantic.error,
    },
    '&:active': {
      bgcolor: semantic.bg.surfaceSelected,
    },
  },
};

/**
 * Shared Action / IconButton (Figma Base).
 * @param {'Sm'|'Md'|'sm'|'md'} [size]
 * @param {'Neutral'|'Danger'} [tone]
 */
export const IconButton = forwardRef(function IconButton(
  {
    size = 'Md',
    tone = 'Neutral',
    disabled = false,
    children,
    sx,
    ...rest
  },
  ref,
) {
  const dimension = SIZE_MAP[size] || SIZE_MAP.Md;
  const toneSx = TONE_STYLES[tone] || TONE_STYLES.Neutral;

  return (
    <MuiIconButton
      ref={ref}
      disabled={disabled}
      sx={{
        width: dimension,
        height: dimension,
        minWidth: dimension,
        borderRadius: `${radiusTokens.iconButton}px`,
        padding: 0,
        flexShrink: 0,
        ...toneSx,
        '&.Mui-disabled': {
          bgcolor: semantic.action.secondary.bg,
          color: semantic.text.disabled,
          border: `1px solid ${semantic.border.subtle}`,
          opacity: 1,
        },
        '& .MuiSvgIcon-root': {
          fontSize: size === 'Sm' || size === 'sm' ? 18 : 20,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiIconButton>
  );
});

export default IconButton;
